import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  setDoc,
  updateDoc,
  where,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/config";

const COLLECTION = "organizations";

function orgRef(organizationId) {
  return doc(db, COLLECTION, organizationId);
}

export async function fetchOrganization(organizationId) {
  if (!organizationId) return null;
  const snap = await getDoc(orgRef(organizationId));
  if (!snap.exists()) return null;
  return { id: snap.id, organizationId: snap.id, ...snap.data() };
}

export async function createOrganization(organizationId, data) {
  await setDoc(orgRef(organizationId), {
    ...data,
    organizationId,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export async function updateOrganization(organizationId, data) {
  await updateDoc(orgRef(organizationId), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

/**
 * @param {{ max?: number, type?: string }} [options]
 */
export async function listOrganizations(options = {}) {
  const max = Math.min(options.max || 50, 80);
  const constraints = [where("isActive", "==", true), orderBy("updatedAtMs", "desc"), limit(max)];
  if (options.type) {
    // Prefer type filter without composite when possible — fetch then client filter if needed
  }
  try {
    const q = query(collection(db, COLLECTION), ...constraints);
    const snap = await getDocs(q);
    return snap.docs.map((d) => ({ id: d.id, organizationId: d.id, ...d.data() }));
  } catch {
    const q = query(collection(db, COLLECTION), limit(max));
    const snap = await getDocs(q);
    return snap.docs
      .map((d) => ({ id: d.id, organizationId: d.id, ...d.data() }))
      .filter((o) => o.isActive !== false);
  }
}

/**
 * Keyword search via array-contains.
 * @param {string} token
 * @param {{ max?: number }} [options]
 */
export async function searchOrganizationsByKeyword(token, options = {}) {
  const max = Math.min(options.max || 40, 50);
  const t = String(token || "")
    .trim()
    .toLowerCase();
  if (!t || t.length < 2) {
    return listOrganizations({ max });
  }
  try {
    const q = query(
      collection(db, COLLECTION),
      where("isActive", "==", true),
      where("searchKeywords", "array-contains", t.slice(0, 40)),
      limit(max)
    );
    const snap = await getDocs(q);
    return snap.docs.map((d) => ({ id: d.id, organizationId: d.id, ...d.data() }));
  } catch {
    const all = await listOrganizations({ max: 80 });
    return all.filter(
      (o) =>
        (o.normalizedName || "").includes(t) ||
        (o.searchKeywords || []).some((k) => k.includes(t))
    );
  }
}

export { COLLECTION as ORGANIZATIONS_COLLECTION };
